/** @jsx jsx */
import {jsx} from '@emotion/core'
import {FunctionComponent} from 'react'
import {RouteProps} from './types/types'

const Route: FunctionComponent<RouteProps> = ({
  component: Component,
  ...rest
}) => <Component {...rest} />

export default Route
